import { action, observable, makeObservable } from 'mobx';
import { RemoteResourceV3, updateRemoteResourceV3 } from '../../../../commonv3/api/RemoteResourceV3';
import { LessonHomeworkSubmissionToken } from '../../../../commonv3/types/lesson_homework_submissions';
import { SubmissionCommentListState } from '../../../components/organisms/submission_comments/state/SubmissionCommentListState';
import { SubmissionCommentTargetType } from '../../../../commonv3/types/submission_comments';
import { ExamPracticalSubmissionApis } from '../../../apis/examPracticalSectionSubmissions';
import { ExamPracticalSectionSubmissionToken } from '../../../../commonv3/types/courseExams';
import { ExamPracticalSectionSubmissionShowView } from '../../../types/exam_sections';
import { SubmissionEvaluationResultState } from '../../../components/organisms/submission_evaluation_results/SubmissionEvaluationResultState';

export class ExamPracticalSectionSubmissionShowPageState {
  token: LessonHomeworkSubmissionToken = null;
  submission: RemoteResourceV3<ExamPracticalSectionSubmissionShowView> = RemoteResourceV3.loading();
  commentState = new SubmissionCommentListState();
  submissionEvaluationResultState = new SubmissionEvaluationResultState();

  constructor() {
    makeObservable(this, {
      token: observable,
      submission: observable,
      commentState: observable,
      submissionEvaluationResultState: observable,
      init: action.bound,
      submitComment: action.bound,
    });
  }

  async init(token: ExamPracticalSectionSubmissionToken) {
    this.token = token;
    const submission = await this.reloadSubmission();
    if (submission) {
      await this.commentState.init(SubmissionCommentTargetType.EXAM_PRACTICAL_SECTION_SUBMISSION, submission.id);
      await this.submissionEvaluationResultState.init(submission.token);
    }
  }

  async reloadSubmission() {
    return await updateRemoteResourceV3(
      this.submission,
      (v) => (this.submission = v),
      () => ExamPracticalSubmissionApis.show(this.token)
    );
  }

  async submitComment() {
    try {
      const comment = await this.commentState.create();
      if (comment) {
        await this.reloadSubmission();
      }
    } catch (e) {}
  }
}
